<ng-container *appTranslate="let t; lang: viewLanguage + '|static'">
  <p-tabs class="h-full" [value]="consents?.[0]?.language" [scrollable]="true">
    <div
      [class]="!dialogMode ? 'px-4 border-b-1 border-surface-border bg-surface-bg-grey' : undefined"
      [class.hidden]="consents?.length < 2"
    >
      <p-tablist>
        @for (consent of consents; track consent.language) {
          <p-tab [value]="consent.language">
            {{ t($any("enum.language." + ensure4LetterIsoLanguage(consent.language))) }}
          </p-tab>
        }
      </p-tablist>
    </div>

    <p-tabpanels class="overflow-y-auto">
      @for (consent of consents; track consent.language) {
        <p-tabpanel [value]="consent.language">
          <div class="ql-snow">
            <div class="ql-editor p-4" [innerHtml]="consent.contents | safe: 'html'"></div>
          </div>
        </p-tabpanel>
      }
    </p-tabpanels>
  </p-tabs>
</ng-container>
